KTUtil.onDOMContentLoaded(function() {
    $('.close-custom-notification').click(function(e) {
        const notification = $(this).parent();
        $.ajax({
            url: '/dashboard?do=hideNotification',
            type: 'GET',
            dataType: '',
            data:{ notificationUuID: e.currentTarget.attributes.uuid.value }
        }).done(function () {
            notification.fadeOut(500, function() {
                $(this).remove();
            });
        });
    });
});